





































































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';
import XLSX from 'xlsx';
import Combobox from "@/components/Controls/Combobox.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'data', 'documents'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX'
    ])
  },
  components: {
    TitleBar,
    Combobox
  }
})
export default class ResultPPReport extends Vue {
  sortingPriority: any[] = [{"field": "shift_date","order": "asc"}];

  columnsList: any[] = [
    {id: 'number', label: '№ партии после мойки'},
    {id: 'shift_date', label: 'Дата и № партии'},
    {id: 'base_name', label: 'База'},
    {id: 'starter_type_name', label: 'Закваска'},
    {id: 'starter_type_temp', label: 'Рекомендуемая t заквашивания'},
    {id: 'temp_range', label: 'Фактическая t заквашивания'},
    {id: 'starter_type_temp', label: 'Продолжительность сквашивания, ч'},
    {id: 'ph_h_range', label: 'pH норма'},
    {id: 'acidity_range', label: 'pH факт'},
    {id: 'rotates', label: 'Ротация'},
    {id: 'mark', label: 'Оценка'},
  ]
  showColumns: any[] = []

  get titleStack () {
    return [
      'Отчеты',
      'По результатам ПП'
    ]
  }

  localFilter = {
    employeeId: null,
    targetDates: [new Date(), new Date()],
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'delivery_zone_address', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.employeeId = (this.$route.query && this.$route.query.employeeId)? this.$route.query.employeeId : null;
    // @ts-ignore
    this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? [moment(this.$route.query.targetDates[0]).toDate(), moment(this.$route.query.targetDates[1]).toDate()] : [new Date(), new Date()];

    this.handleParamsChange();

    this.showColumns = this.columnsList.map((col: any) => {
      return col.id;
    });
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')] : this.localFilter[key]
      return ac;
    }, {});

    this.$router.replace({
      query
    })
  }

tableToExcel() {
  const csvContent: any[] = [];

  csvContent.push(...this.$store.getters[`${STORE_KEY}/exportData`]);
  const ws = XLSX.utils.aoa_to_sheet(csvContent);
  // @ts-ignore
  const range = XLSX.utils.decode_range(ws['!ref']);
  for(let R = range.s.r; R <= range.e.r; ++R) {

    for(let C = range.s.c; C <= range.e.c; ++C) {
      const cellref = XLSX.utils.encode_cell({c:C, r:R}); // construct A1 reference for cell
      if(!ws[cellref] || C < 2 || R < 1) continue; // if cell doesn't exist, move on
      const cell = ws[cellref];
      cell.t = 'n'
      cell.z = '0.00'
    }
  }
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Отчет");
  XLSX.writeFile(wb, 'export.xlsx')
}

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
